<template>
    <div>
        <div class="main-inner">
            <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)"
                  id="createUser">
                <div class="row align-items-center mb-3">
                    <div class="col-12 col-md-6 col-xl-4">
                        <h1 class="mb-0">Gebruiker toevoegen</h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-12 col-xl-8">
                        <div class="block">
                            <p>Voer onderstaand formulier in om een gebruiker aan te maken.</p>

                            <div class="alert alert-danger" v-if="error" v-text="error"></div>
                            <div class="alert alert-success" v-if="success" v-text="success"></div>

                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('name') }">
                                <label class="form-label" for="name">Naam</label>
                                <input id="name" class="form-control" type="text" v-model="form.name">
                            </div>

                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('email') }">
                                <label class="form-label" for="email">E-mailadres</label>
                                <input id="email" class="form-control" type="email" v-model="form.email">
                            </div>

                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('phone') }">
                                <label class="form-label" for="phone">Telefoonnummer</label>
                                <input id="phone" class="form-control" type="tel" v-model="form.phone">
                            </div>

                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('role') }">
                                <label class="form-label" for="name">Rol</label>
                                <select name="role" id="role" class="form-control" v-model="form.role">
                                    <option :key="role.id" :value="role.id" v-for="role in availableRoles">{{ role.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('company') }">
                                <label class="form-label" for="name">Bedrijf of opdrachtgever</label>
                                <select name="company" id="company" class="form-control" v-model="form.company">
                                    <option value="0">Geen bedrijf</option>
                                    <option :key="company.id" :value="company.id" v-for="company in companies">{{ company.name }}
                                    </option>
                                </select>
                            </div>

                            <label for="active" class="d-block">
                                <input type="checkbox" name="send-welcome-mail" id="active" v-model="form.active" style="margin-right: 10px;">Geactiveerd
                            </label>

                            <label for="welcome-mail" class="d-block">
                                <input type="checkbox" name="send-welcome-mail" id="welcome-mail" v-model="form.inviteUser" style="margin-right: 10px;">Verstuur uitnodiging per e-mail
                            </label>

                            <label for="customized-permissions" class="d-block">
                                <input type="checkbox" name="customized-permissions" id="customized-permissions" v-model="form.customizedPermissions" style="margin-right: 10px;">Aangepaste rechten
                            </label>

                            <div v-if="!form.inviteUser">
                                <div class="form-group" :class="{ 'is-invalid': form.errors.has('password') }">
                                    <label class="form-label" for="password">Wachtwoord</label>
                                    <input id="password" class="form-control" type="password" v-model="form.password">
                                </div>

                                <div class="form-group"
                                     :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                                    <label class="form-label" for="password_confirmation">Wachtwoord nogmaals</label>
                                    <input id="password_confirmation" class="form-control" type="password"
                                           v-model="form.password_confirmation">
                                </div>
                            </div>
                        </div>

                        <div class="block" style="background: #FFF;padding: 30px;margin-top: 30px;"
                             v-if="form.customizedPermissions">
                            <h3>Aangepaste rechten</h3>

                            <ul class="checkbox-list">
                                <li v-for="permission in permissions" :key="permission.id">
                                    <input type="checkbox" :id="permission.id" :value="permission.id"
                                           v-model="form.selectedPermissions">
                                    <label :for="permission.id">{{permission.name}}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="footer">
            <div class="footer__left">
                <router-link :to="{ name: 'users' }" class="btn btn-grey">Terug naar overzicht</router-link>
            </div>

            <div class="footer__right">
                <input type="submit" value="Gebruiker toevoegen" class="btn btn-primary" form="createUser">
            </div>
        </div>
    </div>
</template>

<script>
	import {FETCH_ROLES} from '@/store/modules/roles';
	import {CREATE_USER} from '@/store/modules/users';
	import {FETCH_PERMISSIONS} from '@/store/modules/permissions';
	import {FETCH_ALL_COMPANIES} from '@/store/modules/companies';
	import {SET_LOADING} from '@/store/modules/loader';
	import Form from '@/utilities/Form';
	import {mapGetters} from 'vuex';

	export default {
		mounted() {
			this.fetchData();
		},

		computed: {
			...mapGetters( [
				'roles',
				'permissions',
			] ),
			availableRoles() {
				return this.roles;
			},
		},

		data() {
			return {
				error: null,
				success: null,
				isLoading: false,
				companies: [],
				form: new Form( {
					name: null,
					email: null,
					phone: null,
					role: 3,
					company: 0,
                    active: true,
					inviteUser: true,
					customizedPermissions: false,
					password: null,
					password_confirmation: null,
					selectedPermissions: [],
				} ),
			};
		},

		methods: {
			onSubmit() {
				if ( this.form.inviteUser === false && (
					this.form.password !== this.form.password_confirmation
				) ) {
					this.error = 'Het wachtwoord komt niet overeen met de bevestiging.';

					return;
				}

				this.$store.dispatch( SET_LOADING, true );

				this.$store.dispatch( CREATE_USER, this.prepareFormData( this.form ) ).then( () => {
					this.$store.dispatch( SET_LOADING, false );
					this.success = 'De gebruiker is succesvol toegevoegd.';
				} ).catch( ( response ) => {
					if ( response.errors ) {
						this.form.errors.record( response.errors );
					} else {
						this.error = 'Er is een fout opgetreden. Controleer de velden en probeer het opnieuw.';
					}

					this.$store.dispatch( SET_LOADING, false );
				} );
			},

			prepareFormData( formData ) {
				let object = {};

				if ( formData.inviteUser === false ) {
					object.password = formData.password;
				} else {
					object.invite_user = true;
				}

				if ( formData.customizedPermissions === true ) {
					object.permissions = formData.selectedPermissions;
				}

				return Object.assign( {}, object, {
					name: formData.name,
					email: formData.email,
					phone: formData.phone,
					role: formData.role,
					company_id: formData.company,
                    active: formData.active
				} );
			},

			fetchData() {
				this.$store.dispatch( SET_LOADING, true );

				let roles = this.$store.dispatch( FETCH_ROLES );
				let permissions = this.$store.dispatch( FETCH_PERMISSIONS );
				let companies = this.$store.dispatch( FETCH_ALL_COMPANIES ).then( ( data ) => this.companies = data );

				Promise.all( [roles, permissions, companies] ).then( () => {
					this.$store.dispatch( SET_LOADING, false );
				} );
			},
		},
	};
</script>